import React from 'react';
import {
  Breakpoints,
  ButtonAppearance,
  ButtonCustom,
  buttonPaddingGenerator,
  TextAppearance,
  TextColor,
  TextCustom,
  TextLineHeight,
  TextSize,
  TextTag,
  TextWeight,
} from '@vw-marketing/us-components';
import {useTranslations} from '../../hooks/use-translations';
import LineWrapper from '../../components/line-wrapper';
import {UsedVehicle} from '../../typing/used-inventory';
import {
  StyledDetailsContent,
  StyledPriceDetails,
  StyledPriceDetailsLine,
  StyledSeparatorLine,
  StyledButton,
  StyleBuyingCTAs,
  StyledTagContainer,
  StyledOfferTypeLabel,
} from './styles';
import {DEFAULT_CURRENCY_MAP} from '../../utils/app-constants';
import {
  isOnlineBuyingLinkModified,
  separateThousand,
} from '../../utils/general';

import {BuildTheDeal} from '../icons/BuildTheDeal';
import {InfoToolTip} from '../info-tool-tip/InfoToolTip';
import {onVWBasicVehicleButtonClick} from '../../tagging/tagging-helpers';
import {modalsData} from '../../store/local-storage';
import {ModalDisplayMode} from '../../typing/modal-display';
import {useTrackingManager} from '../../hooks/use-tracking-manager';
interface BuyingProcessProps {
  vehicle: UsedVehicle;
  onHandleMakeOffer: () => void;
  zipcode: string;
}

const BuyingProcess: React.FC<BuyingProcessProps> = ({
  vehicle,
  onHandleMakeOffer,
}) => {
  const trackingManager = useTrackingManager();
  const translations = useTranslations().detailsSection.buyingProcessBox;
  const {buildMyDeal} = useTranslations();
  const vehicleMsrp: Number = vehicle.adjustedListPrice
    ? Number(vehicle.adjustedListPrice)
    : 0;

  const onHandleBuyingTransition = (
    vehicle: UsedVehicle,
    vehiclePosition: number,
  ) => {
    const filter = {url: window.location.href, name: 'Build my Deal'};
    onVWBasicVehicleButtonClick(vehicle, filter, trackingManager);
    modalsData({
      vehicle,
      active: true,
      mode: ModalDisplayMode.HANDOFF_BUYING,
      vehiclePosition,
    });
  };

  const textStyleProps = {
    appearance: TextAppearance.label100,
    style: {
      [Breakpoints.default]: {
        fontWeight: TextWeight.bold,
        fontSize: TextSize.TextSize16,
        lineHeight: TextLineHeight.TextLineHeight16,
      },
      [Breakpoints.b960]: {
        fontWeight: TextWeight.bold,
        fontSize: TextSize.TextSize16,
        lineHeight: TextLineHeight.TextLineHeight20,
      },
      [Breakpoints.b1600]: {
        fontWeight: TextWeight.bold,
        fontSize: TextSize.TextSize16,
        lineHeight: TextLineHeight.TextLineHeight16,
      },
    },
  };

  return (
    <LineWrapper label={translations.lineWraper} variant={true}>
      <StyledDetailsContent className="price-details-content">
        {isOnlineBuyingLinkModified(vehicle) && (
          <StyledTagContainer>
            <StyledOfferTypeLabel>
              <TextCustom
                appearance={TextAppearance.headline100}
                tag={TextTag.span}
                style={{
                  [Breakpoints.default]: {
                    fontSize: TextSize.TextSize16,
                    lineHeight: TextLineHeight.TextLineHeight20,
                    color: TextColor.inherit,
                    fontWeight: TextWeight.bold,
                  },
                }}
              >
                <BuildTheDeal iconSize={18} /> {buildMyDeal.onlineSalesLabel}
              </TextCustom>
            </StyledOfferTypeLabel>
            <InfoToolTip />
          </StyledTagContainer>
        )}
        <TextCustom {...textStyleProps}>{translations.priceDetails}</TextCustom>
        <StyledSeparatorLine className="separator-line"></StyledSeparatorLine>
        <StyledPriceDetails className="price-details">
          <StyledPriceDetailsLine className="price-details-line">
            <TextCustom {...textStyleProps}>{translations.msrp}</TextCustom>
            <TextCustom {...textStyleProps}>
              {`${DEFAULT_CURRENCY_MAP.US}${separateThousand(
                `${vehicleMsrp}`,
              )}`}
            </TextCustom>
          </StyledPriceDetailsLine>
        </StyledPriceDetails>
      </StyledDetailsContent>
      <StyleBuyingCTAs>
        <StyledButton>
          {/* @ts-ignore */}
          <ButtonCustom
            appearance={ButtonAppearance.Primary}
            onClick={
              isOnlineBuyingLinkModified(vehicle)
                ? onHandleBuyingTransition.bind(null, vehicle, 1)
                : onHandleMakeOffer
            }
            padding={buttonPaddingGenerator(10, 10, 10, 21)}
          >
            <TextCustom
              appearance={TextAppearance.copy100}
              style={{
                color: TextColor.inherit,
              }}
            >
              {isOnlineBuyingLinkModified(vehicle)
                ? buildMyDeal.onlineSalesLabel
                : translations.makeAnOfferCTA}
            </TextCustom>
          </ButtonCustom>
        </StyledButton>
      </StyleBuyingCTAs>
    </LineWrapper>
  );
};

export default BuyingProcess;
